import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA, signal, OnDestroy } from '@angular/core';
import { RouterLink, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SupabaseService } from '../../supabase/supabase.service';
import { supabase } from '../../supabase/supabase.client';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [RouterLink, CommonModule],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NavbarComponent implements OnInit, OnDestroy {
  isLoggedIn = signal(false);
  isAdmin = signal(false);
  userEmail = signal('');
  mobileServicesOpen = signal(false);
  private authSubscription: any;

  constructor(private supabaseService: SupabaseService, private router: Router) {}

  ngOnInit() {
    this.checkAuthStatus();
    this.subscribeToAuthChanges();
  }

  ngOnDestroy() {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }

  private subscribeToAuthChanges() {
    // Subscribe to auth state changes
    this.authSubscription = supabase.auth.onAuthStateChange((event, session) => {
      if (session?.user) {
        this.isLoggedIn.set(true);
        this.userEmail.set(session.user.email || '');
        const role = (session.user as any)?.user_metadata?.role;
        this.isAdmin.set(role === 'admin');
      } else {
        this.isLoggedIn.set(false);
        this.isAdmin.set(false);
        this.userEmail.set('');
        // Redirect from admin page if user logs out
        if (this.router.url === '/admin') {
          this.router.navigate(['/home']);
        }
      }
    });
  }

  private async checkAuthStatus() {
    const { data } = await this.supabaseService.getUser();
    if (data?.user) {
      this.isLoggedIn.set(true);
      this.userEmail.set(data.user.email || '');
      const role = (data.user as any)?.user_metadata?.role;
      this.isAdmin.set(role === 'admin');
    } else {
      this.isLoggedIn.set(false);
    }
  }

  async onSignOut() {
    await this.supabaseService.signOut();
    this.isLoggedIn.set(false);
    this.isAdmin.set(false);
    // Redirect to home page after sign out
    this.router.navigate(['/home']);
  }

  toggleMobileServices() {
    this.mobileServicesOpen.set(!this.mobileServicesOpen());
  }
}
